const IntegerOnly = (value, min=null, max=null) => {
    const newvalue = value.replace(new RegExp(/[^\d]/, "ig"), "")
    if (newvalue === "" && min !== null)
        return min
    if (min !== null && Number(value) < Number(min))
        return min 
    if (max !== null&& Number(value) > Number(max))
        return max 
    
    return newvalue
}

export default IntegerOnly